import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { useRedirectToPro } from "@hooks/siteURLs"
import StatementModule from "@modules/StatementModule"
import { useBreakpoints } from "@hooks/useBreakpoints"
const UnLimitModule = ({ image }) => {
  const { t } = useTranslation()
  const url = useRedirectToPro()

  const { isDesktop } = useBreakpoints()
  const params = {
    theme: "blue-bg",
    text: [{ text: t("AboutMetaloop_MissionStatement") }],
    image: isDesktop ? "metal-shavings-background-two.png" : null,
    classes: { background: "desk:opacity-75" },
    buttons: [
      {
        text: t("About_Button1"),
        as: "link",
        url,
        useNavigate: false,
        theme: "blue-bg",
        inverted: true,
        dataEventId: "pro form_about metaloop_Get started",
      },
      {
        text: t("AboutMetaloop_CTA_Chat"),
        as: "link",
        url: "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ1kd4lu-7e_Th725jDj85XtJ91fL9ctPnwtctWkuTPrprua86XllJmsLKNPVLQZJYOXfq1tnH5y",
        theme: "blue-bg",
        inverted: false,
        dataEventId: "calendar Patrick_about metaloop_Let’s chat",
      },
    ],
  }

  return <StatementModule {...params} />
}

export default UnLimitModule
